import { render } from "./HomeDeslogado.vue?vue&type=template&id=5e48d96a"
import script from "./HomeDeslogado.vue?vue&type=script&lang=js"
export * from "./HomeDeslogado.vue?vue&type=script&lang=js"
script.render = render

export default script